module.exports = __webpack_public_path__ + "static/office_people-2e7ec132048f42f3c8881830ae4c2c8e.jpg";